import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { FormgenFieldControlBComponent } from '../field-control/formgen-field-control.bcomponent';

@Component({
  selector: 'app-formgen-field-select',
  templateUrl: './formgen-field-select.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class FormgenFieldSelectComponent extends FormgenFieldControlBComponent {
  onChange($event) {
    this.callEvent('onChange', $event);
  }
}
